import React from "react";
const isSmallScreen = window.innerWidth <= 400;
const styles = {
  stepperContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px 0 20px 0",
    padding: "0px 130px",
    // backgroundColor: "green",
  } as React.CSSProperties,
  stepperStep: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } as React.CSSProperties,
  stepCircle: {
    width: isSmallScreen? "30px": "40px",
    height: isSmallScreen? "30px": "40px",
    borderRadius: "50%",
    backgroundColor: "#d1d5db",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: isSmallScreen? "16px":"20px",
    fontWeight: "bold",
    color: "white",
    transition: "all 0.3s ease",
  } as React.CSSProperties,
  activeCircle: {
    backgroundColor: "#f59e0b",
    boxShadow: "0 0 0 4px rgba(245, 158, 11, 0.2)",
  } as React.CSSProperties,
  completedCircle: {
    backgroundColor: "#f59e0b",
  } as React.CSSProperties,
  stepperLine: {
    width: "200px",
    // height: "2px",
    borderBottom: "2px dotted #d1d5db",
    // backgroundColor: "#d1d5db",
    margin: "0 10px",
    transition: "all 0.3s ease",
  } as React.CSSProperties,
  completedLine: {
    // backgroundColor: "#f59e0b",
    borderBottom: "2px dotted #f59e0b",
  } as React.CSSProperties,
  stepNavigation: {
    display: "flex",
    justifyContent: "space-between",
    margin: "20px 0",
    padding: "0 20px",
  } as React.CSSProperties,
  stepContent: {
    padding: "20px",
  } as React.CSSProperties,
};

interface StepperProps {
  currentStep: number;
  totalSteps: number;
}

const Stepper: React.FC<StepperProps> = ({ currentStep, totalSteps }) => {
  return (
    <div style={styles.stepperContainer}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;

        const circleStyle = {
          ...styles.stepCircle,
          ...(isCompleted && styles.completedCircle),
          ...(isActive && styles.activeCircle),
        };

        const lineStyle = {
          ...styles.stepperLine,
          ...(isCompleted && styles.completedLine),
        };

        return (
          <React.Fragment key={stepNumber}>
            <div style={styles.stepperStep}>
              <div style={circleStyle}>
                <span>{stepNumber}</span>
              </div>
            </div>
            {stepNumber < totalSteps && <div style={lineStyle} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
